import { Actions, createEffect, ofType } from '@ngrx/effects';
import { Injectable } from '@angular/core';
import { ApiService } from '../../../services/api/api.service';
import { mergeMap } from 'rxjs/operators';
import { UpdateGroupAction } from '../../actions/groups/update-group-action';
import { UpdateGroupErrorAction } from '../../actions/groups/update-group-error-action';
import { GetGroupsAction } from '../../actions/groups/get-groups-action';

@Injectable()
export class UpdateGroupEffect {
  constructor(private api: ApiService, private actions: Actions) {
  }


  public UpdateGroup = createEffect(() => this.actions
    .pipe(
      ofType(UpdateGroupAction.type),
      mergeMap(action => {
        const updateGroupAction = <UpdateGroupAction>action;
        return this.api.updateGroup(updateGroupAction.group).then(() => {
          return new GetGroupsAction(updateGroupAction.bijbEvent);
        }, error => {
          return new UpdateGroupErrorAction(error);
        });
      })
    ));
}
